import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type MapTheme = 'light' | 'dark';

interface MapThemeState {
  /** Base map look: light streets (default) or the dark night map. Remembered on this device. */
  theme: MapTheme;
  toggle: () => void;
}

export const useMapTheme = create<MapThemeState>()(
  persist((set) => ({ theme: 'light', toggle: () => set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })) }), {
    name: 'rw:map-theme',
    storage: createJSONStorage(() => localStorage),
  }),
);
